export interface IConteudo {
  subtitulo: string;
  paragrafo: string;
  imagem?: string;
  video?: string;
}

export const placeHolderContent: IConteudo = {
  paragrafo: "",
  subtitulo: "",
  imagem: "",
  video: "",
};
